import React from 'react';
import { Route } from 'react-router-dom';
import { ContainerWrapper } from '../../components';
import PricinglistsList from './PricinglistsList/PricinglistsList';
import PricinglistEdit from './PricinglistEdit/PricinglistEdit';
import PricinglistCreate from './PricinglistCreate/PricinglistCreate';
import PricinglistDelete from './PricinglistDelete/PricinglistDelete';

const Pricinglists = ({ match }) => {
    return (
        <div className="Pricinglists">
            <ContainerWrapper container="pricinglists">
                <Route exact path={ match.path } component={PricinglistsList} />
                <Route exact path={ `${ match.url }/new` } component={PricinglistCreate} />
                <Route exact path={ `${ match.url }/edit/:pricinglistId` } component={PricinglistEdit} />
                <Route exact path={ `${ match.url }/delete/:pricinglistId` } component={PricinglistDelete} />
            </ContainerWrapper>
        </div>
    );
}

export default Pricinglists;
